export default __webpack_public_path__ + "static/media/transfer-send-step4.86336084.png";